import type { ActivityItem, DashboardOverview } from '@qualibot/shared';
import { api } from './api-client';

export async function fetchDashboardOverview(): Promise<DashboardOverview> {
  const { data } = await api.get<DashboardOverview>('/api/dashboard/overview');
  return data;
}

export async function fetchRecentActivity(): Promise<ActivityItem[]> {
  const { data } = await api.get<{ items: ActivityItem[] }>('/api/dashboard/activity');
  return data.items;
}
